import { IconButton, IconButtonProps } from '@mui/material';
import React, { ReactNode } from 'react';

interface RedirectIconButtonProps extends IconButtonProps {
    to: string;
    children: ReactNode;
}

const RedirectIconButton: React.FC<RedirectIconButtonProps> = ({ to, children, ...props }) => {
    const handleClick = React.useCallback(() => {
        window.location.href = to; 
    }, [to]);

    return (
        <IconButton onClick={handleClick} {...props}>
            {children}
        </IconButton>
    );
};

export default RedirectIconButton;
